import { ChartDatum } from 'funds-model';
import { AxisSetExtremesEventObject, Options } from 'highcharts/highstock';
import { Theme } from '../styles/styles';
import { ChartType } from './FundBigChart';
import Decimal from 'decimal.js';
import { createTooltipOptions } from '../utils/highChartTooltipGenerator';
import { formatNumber } from '../utils/formatters';
import {
  buildCompactLegendOptions,
  buildSharedStockChartBaseOptions,
  buildSharedStockSeries,
} from '../utils/highchartsSharedOptions';

const maximumFractionDigits = 2;

function formatChange(change: number) {
  return (change > 0 ? '+' : '') + (change * 100).toLocaleString('pl', { style: 'decimal', maximumFractionDigits });
}

export function buildOptions(
  datas: ChartDatum[][],
  locale: string,
  chartType: ChartType,
  fundsNameWithColor: { name: string, color: string}[],
  handleNavigatorChange: (event: AxisSetExtremesEventObject) => void,
  theme: Theme,
  isMobile: boolean,
  embeddedInFundPopup = false,
  isDarkTheme = false,
  hiddenSeriesNames: string[] = [],
  handleLegendVisibilityChange?: (seriesName: string) => void
): Options {
  const series = buildSharedStockSeries({
    datas,
    entries: fundsNameWithColor,
    hiddenSeriesNames,
  });

  const setHeightChart = () => {
    if (series.length > 4) {
      return isMobile ? 600 : 500;
    }
    return null;
  };

  const tooltip = createTooltipOptions({
    isMobile,
    locale,
    theme,
    isDarkTheme,
    formatNumber,
    formatValue: (value: number) => chartType === ChartType.PRICING_CHART_TYPE
      ? `${formatNumber(new Decimal(value))} PLN`
      : `${formatChange(value)}%`,
  });

  const options = buildSharedStockChartBaseOptions({
    theme,
    isDarkTheme,
    series,
    handleNavigatorChange,
    handleLegendVisibilityChange,
    tooltip,
    ...buildCompactLegendOptions({ theme, isMobile }),
    legendEnabled: !embeddedInFundPopup,
    chartHeight: setHeightChart(),
    isNavigatorEnabled: !isMobile,
    axisLightColor: theme.color.greys[15],
    axisLabelColor: theme.color.greys[50],
    navigatorGridLineLightColor: theme.color.greys[15],
    navigatorLabelColor: theme.color.greys[50],
    yAxisOverrides: {
      labels: {
        formatter(this: { value: number | string }) {
          const percentValue = formatNumber(new Decimal(Number(this.value) * 100), 2, false);
          return chartType === ChartType.ROI_CHART_TYPE ? `${percentValue}%` : this.value;
        },
      },
    },
  });

  return options;
}
